import { Action } from 'redux';
import { CustomerState } from '../store.types';
import { createObjectFromQueryString } from '../../utils/queryHelpers';
import { SolarProduct } from '../../../__generated__/globalTypes';

export function getInitialProductType(): SolarProduct {
  const qs = createObjectFromQueryString();

  if (!qs.productType) {
    return SolarProduct.SOLAR;
  }

  switch (qs.productType) {
    case SolarProduct.SOLAR:
      return SolarProduct.SOLAR;
    case SolarProduct.BATTERY:
      return SolarProduct.BATTERY;
    case SolarProduct.SOLAR_AND_BATTERY:
      return SolarProduct.SOLAR_AND_BATTERY;
    default:
      return SolarProduct.SOLAR;
  }
}

export function getInitialCustomerState(): CustomerState {
  return {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    comment: '',
    address: '',
    unit: '',
    streetNumber: '',
    streetName: '',
    streetType: '',
    suburb: '',
    city: '',
    state: '',
    hiddenPostcode: 'true',
    propertyType: undefined,
    roofType: undefined,
    roofPitch: undefined,
    propertyStorey: undefined,
    powerConnectionPhaseType: undefined,
    postcode: '',
    productType: getInitialProductType(),
    enquiryType: '',
    allowMarketingCommunications: false,
    averageBill: '',
    usagePercentDuringDay: '',
    hasManualAddress: false,
    averageQuarterlyBillCost: '',
    calculatorValues: {}
  };
}

export interface CustomerDetailsAction extends Action {
  payload: {
    [key: string]: string;
  };
}

const customer = (state = getInitialCustomerState(), action: CustomerDetailsAction) => {
  switch (action.type) {
    case 'UPDATE_CUSTOMER_DETAIL':
      return { ...state, ...action.payload };

    case 'RESET_CUSTOMER_DETAIL':
      return { ...getInitialCustomerState() };

    default:
      return state;
  }
};

export default customer;
